import React from 'react';
import { LanguageProvider } from './context/LanguageContext';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustStrip } from './components/TrustStrip';
import { About } from './components/About';
import { Services } from './components/Services';
import { Experience } from './components/Experience';
import { Facilities } from './components/Facilities';
import { Approach } from './components/Approach';
import { Advantages } from './components/Advantages';
import { CooperationFormat } from './components/CooperationFormat';
import { CompanyStatus } from './components/CompanyStatus';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen w-full bg-graphite text-slate-50" data-id="element-1">
        <Header data-id="element-2" />
        <main data-id="element-3">
          <Hero data-id="element-4" />
          <TrustStrip data-id="element-5" />
          <About data-id="element-6" />
          <Services data-id="element-7" />
          <Experience data-id="element-8" />
          <Facilities data-id="element-9" />
          <Approach data-id="element-10" />
          <Advantages data-id="element-11" />
          <CooperationFormat data-id="element-12" />
          <CompanyStatus data-id="element-13" />
          <FAQ data-id="element-14" />
          <Contact data-id="element-15" />
        </main>
        <Footer data-id="element-16" />
      </div>
    </LanguageProvider>;
}